import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { PhoneIphoneOutlined } from "@mui/icons-material";
import { isIphoneHomeScreenApp } from "./pushClient";
import { APP_STORE_URL, openAppStore } from "../native/appStore";

/**
 * The iPhone Home Screen web app is retired in favour of the App Store app
 * (Mostafa, 2026-10-22): a phone that launches Phieg from the old Home
 * Screen icon sees this and nothing else — no login, no leads — until it
 * installs the app from the store. Safari on the same phone keeps working,
 * and the store app itself never shows this (it is not a Home Screen web
 * app). iPads keep the web app: the store app is iPhone-only.
 *
 * Nothing here can delete the icon for them, so the words say how.
 */
export default function MoveToAppStoreGate() {
  if (!isIphoneHomeScreenApp()) return null;

  return (
    <Box
      role="dialog"
      aria-modal="true"
      aria-labelledby="move-to-app-store-title"
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 3000,
        bgcolor: "#1a2a27",
        color: "#eaf2ef",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        pt: "env(safe-area-inset-top)",
        pb: "env(safe-area-inset-bottom)",
      }}
    >
      <Stack spacing={2.5} alignItems="center" sx={{ maxWidth: 340, textAlign: "center" }}>
        <PhoneIphoneOutlined sx={{ fontSize: 48, color: "#7fb09a" }} />
        <Typography id="move-to-app-store-title" variant="h6" sx={{ fontWeight: 700 }}>
          Phieg is now on the App Store
        </Typography>
        <Typography variant="body2" sx={{ color: "#a8bcb6" }}>
          This Home Screen shortcut is being retired. Install the Phieg app from
          the App Store and sign in there — you get notifications the moment a
          lead is assigned to you.
        </Typography>
        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={() => openAppStore(APP_STORE_URL)}
          sx={{
            bgcolor: "#7fb09a",
            color: "#0b1412",
            fontWeight: 700,
            "&:hover": { bgcolor: "#6f9e89" },
          }}
        >
          Open the App Store
        </Button>
        <Typography variant="caption" sx={{ color: "#a8bcb6" }}>
          Once the app is installed, delete this icon: hold it on the Home
          Screen → Remove App → Delete.
        </Typography>
      </Stack>
    </Box>
  );
}
